var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockKeyhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 192H384V128C384 57.422 326.578 0 256 0S128 57.422 128 128V192H96C60.654 192 32 220.654 32 256V448C32 483.346 60.654 512 96 512H416C451.346 512 480 483.346 480 448V256C480 220.654 451.346 192 416 192ZM176 128C176 83.891 211.891 48 256 48S336 83.891 336 128V192H176V128ZM432 448C432 456.822 424.822 464 416 464H96C87.178 464 80 456.822 80 448V256C80 247.178 87.178 240 96 240H416C424.822 240 432 247.178 432 256V448ZM256 304C242.75 304 232 314.75 232 328V376C232 389.25 242.75 400 256 400S280 389.25 280 376V328C280 314.75 269.25 304 256 304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockKeyhole);
export default __webpack_public_path__ + "static/media/lock-keyhole.36a6c541f7d03dc93614f25470717ee7.svg";
export { ForwardRef as ReactComponent };